/** Teléfono MX: lo que se guarda son 10 dígitos; lo que se muestra va agrupado 3-3-4. */
export const PHONE_MX_DIGITS = 10;

/** Los 10 dígitos de lo tecleado. Descarta separadores y lo que sobre. */
export function toPhoneDigits(value: string): string {
    return value.replace(/\D/g, '').slice(0, PHONE_MX_DIGITS);
}

/** Teléfono que llega por deep-link: acepta la lada 52 y devuelve '' si no quedan 10 dígitos. */
export function toPrefillPhone(value: string): string {
    const raw = value.replace(/\D/g, '');
    const digits = raw.length === 12 && raw.startsWith('52') ? raw.slice(2) : raw;
    return digits.length === PHONE_MX_DIGITS ? digits : '';
}

/** Teléfono guardado (`+52…`, con espacios o guiones) a dígitos; uno legacy queda tal cual para que el form lo marque. */
export function fromStoredPhone(value: string | null | undefined): string {
    const raw = (value ?? '').replace(/\D/g, '');
    return raw.length === 12 && raw.startsWith('52') ? raw.slice(2) : raw;
}

/** "5551234567" → "555 123 4567". Ignora lo que no sea dígito. */
export function formatPhoneMx(value: string, separator = ' '): string {
    const digits = value.replace(/\D/g, '');
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}${separator}${digits.slice(3)}`;
    return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6)].join(separator);
}
